import { Flex, MenuButton, OverflowTooltip, TextLabel } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { useLicenseStore } from 'src/models/useLicenseModel';

import { DashboardSection, DashboardSectionKey } from '@Types/index';
import { reportPendo } from '@Utils/setupPendo';
import Multiselect from '@Components/Multiselect';

interface WidgetMenuProp {
  widgetsShowConfig: DashboardSection;
  widgetCategoryChange: (obj: { [key: string]: boolean }) => void;
}

const WidgetCategory = ({
  widgetsShowConfig,
  widgetCategoryChange,
}: WidgetMenuProp) => {
  const { hasCasLicense } = useLicenseStore();
  const { t } = useTranslation('dashboard');
  const renderLabel = (v: string[]) => (
    <>
      <TextLabel mr="2x">{t('dashboard.widgetCategory.label')}:</TextLabel>
      <OverflowTooltip
        PopperProps={{ usePortal: true }}
        label={t('dashboard.widgetCategory.count', {
          count: v.length,
        })}
      >
        {t('dashboard.widgetCategory.count', {
          count: v.length,
        })}
      </OverflowTooltip>
    </>
  );

  let options = [
    DashboardSectionKey.Scam,
    DashboardSectionKey.Quishing,
    DashboardSectionKey.Ransomware,
    DashboardSectionKey.BEC,
    DashboardSectionKey.Summary,
    DashboardSectionKey.SecurityRisk,
    DashboardSectionKey.VA,
    DashboardSectionKey.DLP,
  ];
  if (!hasCasLicense) {
    const sectionsNotShow = [
      DashboardSectionKey.Ransomware,
      DashboardSectionKey.BEC,
      DashboardSectionKey.VA,
    ];
    options = options.filter((v) => !sectionsNotShow.includes(v));
  }

  const stringMap = {
    [DashboardSectionKey.Scam]: t('dashboard.sideBar.scam'),
    [DashboardSectionKey.Ransomware]: t('dashboard.sideBar.ransomware'),
    [DashboardSectionKey.BEC]: t('dashboard.sideBar.bec'),
    [DashboardSectionKey.Summary]: t('dashboard.sideBar.summary'),
    [DashboardSectionKey.SecurityRisk]: t('dashboard.sideBar.securityRisk'),
    [DashboardSectionKey.VA]: t('dashboard.sideBar.virtualAnalyzer'),
    [DashboardSectionKey.DLP]: t('dashboard.sideBar.dlp'),
    [DashboardSectionKey.Quishing]: t('dashboard.sideBar.quishing'),
  };

  const value = Object.keys(widgetsShowConfig).filter(
    (k) =>
      widgetsShowConfig[k as keyof typeof widgetsShowConfig] &&
      options.includes(k as any)
  );

  const setValue = async (v: string[]) => {
    const category: { [k: string]: boolean } = {};
    [...v, DashboardSectionKey.Total].reduce(
      (acc, cur) => ((acc[cur] = true), acc),
      category
    );
    options
      .filter((opt) => !v.includes(opt))
      .reduce((acc, cur) => ((acc[cur] = false), acc), category);
    console.log(category);
    widgetCategoryChange(category);
    reportPendo('WidgetCategory.Section.Checked', {
      section: v,
    });
  };

  return (
    <Multiselect
      value={value}
      options={options}
      renderOption={(v) => stringMap[v as keyof typeof stringMap]}
      onChange={setValue}
      marginLeft="auto"
    >
      {({ getMenuToggleProps }: { getMenuToggleProps: any }) => (
        <MenuButton {...getMenuToggleProps()} variant="secondary">
          <Flex>{renderLabel(value)}</Flex>
        </MenuButton>
      )}
    </Multiselect>
  );
};

export default WidgetCategory;
